// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"552d39c5d496c2d26b64","655":"a55afa0c21e1b578e567"}[chunkId] + ".js";
};